module.exports = __webpack_public_path__ + "static/media/background4.0bd42f5b.jpg";